import React from 'react'
import Helmet from 'react-helmet'
import Favicon from '../../assets/images/favicon.png'
import defaultMetaImg from '../../assets/images/Landing-Slider/1.webp'
import _ from 'lodash'

type Props = {
  title: string
  description?: string
  image?: string
  noIndex?: boolean
}

const SEO = ({ title, description, image, noIndex }: Props): JSX.Element => {
  const defaultDesc =
    'Ayala Land Premier shapes environments with purpose, intuition, and foresight— a vibrant portfolio unfolding for lifestyles of discernment and contemporary business.'

  const jsonLd = {
    '@context': `https://schema.org/`,
    '@type': `Website`,
    description: process.env.GATSBY_SITE_DESCRIPTION,
    url: process.env.GATSBY_SITE_URL,
    image: '',
    publisher: undefined
  }

  const containsForSale = title.toLowerCase().includes('for sale')

  if (containsForSale) {
    title = title.replace(/\s*\bfor Sale\b\s*|,\s*/g, ' ')
  }

  if (!title.includes('Ayala Land Premier') && title.length < 30) {
    if (title.includes('Inquire')) {
      title = title.replace(/-/g, '|')
    }

    title += ' by Ayala Land Premier'
  }

  title = _.startCase(title.toLowerCase())

  return (
    <Helmet defer={false} defaultTitle={title} titleTemplate={title}>
      <html lang="en" />
      <link rel="canonical" href="" />
      <link rel="icon" href={Favicon} type="image/png" />
      <title>{title}</title>
      <meta name="docsearch:version" content="2.0" />
      <meta name="viewport" content="width=device-width,initial-scale=1,shrink-to-fit=no,viewport-fit=cover,user-scalable=0" />
      <meta name="description" content={description || defaultDesc} />
      {title === 'Ayala Land Premier' ? (
        <meta name="google-site-verification" content="RnBTi5t_fCnkTWJE4wmwKSeYMiHgIFnct1KpsgmU25U" />
      ) : null}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description || defaultDesc} />
      <meta property="twitter:image" content={image || defaultMetaImg} />
      <script type="application/ld+json">{JSON.stringify(jsonLd, undefined, 4)}</script>
      <meta property="og:image" content={image || defaultMetaImg} />
      <meta property="og:image:width" content="600" />
      <meta property="og:image:height" content="400" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description || defaultDesc} />
      {noIndex ? <meta name="robots" content="noindex" /> : null}
    </Helmet>
  )
}

export default SEO
